import React, { useState } from 'react';
import { connect } from 'react-redux';

import { Button } from 'redpoints-front-components/index';

import {
  getAuditResultsCreateIncidentsIsLoading,
  getAuditResultsIsLoading,
} from '../../../reducers/assetAudit/auditResults';
import AuditResultsCreateIncidentsModal from './AuditResultsCreateIncidentsModal';
import { translate } from '../../../helpers/languageHelper';

const AuditResultsTableActions = ({
  isLoadingAuditResultsCreateIncidents,
  isLoadingAuditResults,
}) => {
  const [showSaveModal, setShowSaveModal] = useState(false);
  const shouldDisableCreateIncidentsButton =
    isLoadingAuditResults || isLoadingAuditResultsCreateIncidents;

  const handleCloseModal = () => {
    setShowSaveModal(false);
  };

  const handleOnClick = () => {
    setShowSaveModal(true);
  };

  return (
    <div className="audit-results-table-actions">
      <Button
        disabled={shouldDisableCreateIncidentsButton}
        onClick={handleOnClick}
        type="primary"
      >
        {translate('auditResults.table.actions.createMissingLinks')}
      </Button>
      <AuditResultsCreateIncidentsModal
        closeModal={handleCloseModal}
        visible={showSaveModal}
      />
    </div>
  );
};
const mapStateToProps = state => ({
  isLoadingAuditResultsCreateIncidents: getAuditResultsCreateIncidentsIsLoading(
    state
  ),
  isLoadingAuditResults: getAuditResultsIsLoading(state),
});
export default connect(mapStateToProps, {})(AuditResultsTableActions);
